import { getMessages } from '../../../../../../../store/constants';

export const CARD_ASSIGNER_CARD_REMOVED = getMessages().getText('activity_item_card__assigner_card_removed');
export const CARD_ASSIGNER_CARD_ADDED = getMessages().getText('activity_item_card__assigner_card_added');
